import React, { memo, useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Stack, Select, MenuItem, FormControl, InputLabel, Button } from 'investira.react.components';
import { useEntidadesContext } from '../../contexts/EntidadesContext';
import withMessage from '../../hoc/withMessage';
const xTipoAcesso = [{
  value: null,
  label: 'Nenhum'
}, {
  value: 'C',
  label: 'Consulta'
}, {
  value: 'E',
  label: 'Edição'
}, {
  value: 'G',
  label: 'Gerencia'
}, {
  value: 'F',
  label: 'Configuração'
}, {
  value: 'A',
  label: 'Assinatura'
}];
const xDefaultAcessos = {
  RLENQ: null,
  // Tipo de Acesso
  RLVAR: null,
  RLDUR: null,
  RLSTT: null,
  RLBCK: null,
  RLCRL: null,
  RLFEF: null,
  RLCNC: null,
  CFENQ: null
};
const MembroRegras = memo(props => {
  const {
    user,
    open,
    recursosLabels,
    onClose
  } = props;
  const {
    actions
  } = useEntidadesContext();

  // Inicializa acessos vindo de user.acessos, se houver, ou com o padrão
  const [acessos, setAcessos] = useState(xDefaultAcessos);
  const [, setIsSubmitting] = useState(false);
  useEffect(() => {
    if (open) {
      setAcessos({
        ...xDefaultAcessos,
        ...user?.acessos
      });
    } else {
      setAcessos(xDefaultAcessos);
    }
  }, [open, user]);
  const handleChangeAcesso = pKey => pEvent => {
    setAcessos(xPrev => ({
      ...xPrev,
      [pKey]: pEvent.target.value
    }));
  };
  const handleSave = () => {
    setIsSubmitting(true);
    actions.handleModifyMembro({
      usuario_id: user.usuario_id,
      acessos: acessos
    }, rRes => {
      props.onMessageSuccess('Acessos modificados com sucesso.');
      actions.readMembros && actions.readMembros();
      onClose && onClose();
    }, rErr => {
      props.onMessageError('Erro ao modificar acessos.');
    }, () => {
      setIsSubmitting(false);
    });
  };
  return <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Definir Regras de Acessos</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{
        mt: 1
      }}>
          {Object.keys(recursosLabels).map(xKey => <FormControl fullWidth key={xKey} size="small" variant="outlined">
              <InputLabel id={`label-select-${xKey}`} shrink>
                {recursosLabels[xKey]}
              </InputLabel>
              <Select labelId={`label-select-${xKey}`} label={recursosLabels[xKey]} value={acessos[xKey] ?? ''} onChange={handleChangeAcesso(xKey)} displayEmpty>
                {xTipoAcesso.map(xOpt => {
              if (xOpt.value === xTipoAcesso[5].value && !['CFENQ'].includes(xKey)) {
                return null;
              }
              return <MenuItem key={xOpt.value ?? 'Sem Acesso'} value={xOpt.value ?? ''}>
                      {xOpt.label}
                    </MenuItem>;
            })}
              </Select>
            </FormControl>)}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="text" color="primary" onClick={onClose}>
          Cancelar
        </Button>
        <Button variant="contained" color="primary" onClick={handleSave}>
          Salvar
        </Button>
      </DialogActions>
    </Dialog>;
});
export default withMessage(MembroRegras);
